import Proj1 from "../assets/proj1.jpg";
import Proj2 from "../assets/proj2.jpg";
import Proj3 from "../assets/proj3.webp";
import Proj4 from "../assets/proj4.webp";


export const ProjectList = [
  {
    name: "Hotel Room Booking",
    image: Proj1,
    skills: "React,Express.js,MongoDB",
    git:"https://github.com/Mithun120/Booking-app"
  },
  {
    name: "Resume Builder",
    image: Proj2,
    skills: "Django",
    git:"https://github.com/Mithun120/resume_app"
  },
  {
    name: "To-Do List",
    image: Proj3,
    skills: "React,Express.js,MongoDB",
    git:"https://github.com/Mithun120/Todo"
  },
  {
    name: "Company Portfolio",
    image: Proj4,
    skills: "React,Express.js,MongoDB",
    git:"https://github.com/Mithun120/Vox-System"
  },
  
];
